(function (window, document) {
  'use strict';

  var registry = window.SlipstreamKiwiSizeChartEnhancementRegistry;
  var charts = registry && registry.charts ? registry.charts.filter(function (item) {
    return item && item.enabled === true && isValidConfiguration(item);
  }) : [];

  if (!charts.length) {
    return;
  }

  var popupSelector = charts.map(function (chart) {
    return chart.popupSelector;
  }).filter(function (selector, index, selectors) {
    return selectors.indexOf(selector) === index;
  }).join(',');

  waitForKiwiMatch();

  function isValidConfiguration(item) {
    return typeof item.id === 'string' && item.popupSelector && item.kiwiWatermark &&
      item.tableHeaders && item.tableHeaders.imperial && item.tableHeaders.metric &&
      item.tableSignature && item.tableSignature.imperial && item.tableSignature.metric &&
      item.units && item.units.imperial && item.units.metric && item.imageSrc && item.logoSrc && item.headerTitle;
  }

  function waitForKiwiMatch() {
    var observer = new MutationObserver(scan);

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['aria-hidden', 'class', 'hidden', 'style'],
      childList: true,
      subtree: true
    });
    scan();
  }

  function scan() {
    findAll(document, popupSelector).filter(function (popup) {
      return isOpen(popup);
    }).forEach(function (popup) {
      if (popup.querySelector('[data-slipstream-kiwi-enhancement]')) {
        return;
      }

      var matches = charts.map(function (chart) {
        if (popup.textContent.indexOf(chart.kiwiWatermark) === -1) {
          return null;
        }

        var match = matchPopup(chart, popup);
        return match ? { chart: chart, match: match } : null;
      }).filter(Boolean);

      if (matches.length === 1) {
        mount(matches[0].chart, matches[0].match);
      }
    });
  }

  function isOpen(element) {
    var style = window.getComputedStyle(element);

    return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
  }

  function matchPopup(chart, popup) {
    var tables = findAll(popup, 'table');

    if (tables.length !== 2) {
      return null;
    }

    var imperial = tables.filter(function (table) {
      return matchesTable(table, chart.tableHeaders.imperial, chart.tableSignature.imperial);
    });
    var metric = tables.filter(function (table) {
      return matchesTable(table, chart.tableHeaders.metric, chart.tableSignature.metric);
    });

    if (imperial.length !== 1 || metric.length !== 1) {
      return null;
    }

    return {
      popup: popup,
      imperial: { table: imperial[0], block: tableBlock(imperial[0], popup) },
      metric: { table: metric[0], block: tableBlock(metric[0], popup) }
    };
  }

  function matchesTable(table, expectedHeaders, expectedFirstRow) {
    var rows = table.querySelectorAll('tr');

    return rows.length > 1 && matchesCells(rows[0], expectedHeaders) && matchesCells(rows[1], expectedFirstRow);
  }

  function matchesCells(row, expected) {
    var cells = Array.prototype.map.call(row.querySelectorAll('th, td'), function (cell) {
      return normalisedText(cell.textContent).toUpperCase();
    });
    var reference = expected.map(function (value) {
      return normalisedText(value).toUpperCase();
    });

    return cells.length === reference.length && cells.every(function (cell, index) {
      return cell === reference[index];
    });
  }

  function tableBlock(table, popup) {
    var block = table;

    while (block.parentElement && block.parentElement !== popup) {
      if (block.parentElement.querySelectorAll('table').length !== 1) {
        break;
      }
      block = block.parentElement;
    }

    return block;
  }

  function findAll(root, selector) {
    try {
      return Array.prototype.slice.call(root.querySelectorAll(selector));
    } catch (error) {
      return [];
    }
  }

  function mount(chart, match) {
    var marker = '[data-slipstream-kiwi-enhancement="' + chart.id + '"]';

    if (match.popup.querySelector(marker)) {
      return;
    }

    updateHeader(chart, match.popup);
    hideMatchedKiwiImages(chart, match);

    var panel = buildPanel(chart, match);
    match.imperial.block.parentNode.insertBefore(panel, match.imperial.block);
    setActiveUnit(chart, panel, match, 'imperial');
  }

  function updateHeader(chart, popup) {
    var logo = replaceHeaderLogo(chart, popup);
    var title = findHeaderTitle(popup, chart.headerTitle);

    alignLogoWithTitleTop(logo, title);
  }

  function replaceHeaderLogo(chart, popup) {
    var logo = findAll(popup, 'img').filter(function (image) {
      return !image.closest('.ks-chart-individual');
    });

    if (logo.length !== 1) {
      return null;
    }

    logo[0].removeAttribute('srcset');
    logo[0].src = chart.logoSrc;
    logo[0].alt = 'Slipstream';
    logo[0].setAttribute('data-slipstream-kiwi-header-logo', chart.id);
    return logo[0];
  }

  function findHeaderTitle(popup, sourceTitle) {
    var candidates = findAll(popup, '*').filter(function (node) {
      return normalisedText(node.textContent) === sourceTitle;
    });

    var exactTitle = candidates.reduce(function (deepest, candidate) {
      if (!deepest || deepest.contains(candidate)) {
        return candidate;
      }

      return deepest;
    }, null);

    if (exactTitle) {
      return exactTitle;
    }

    var labelledBy = popup.getAttribute('aria-labelledby');
    var labelledTitle = labelledBy ? document.getElementById(labelledBy) : null;

    return labelledTitle && popup.contains(labelledTitle) ? labelledTitle : null;
  }

  function alignLogoWithTitleTop(logo, title) {
    if (!logo || !title) {
      return;
    }

    function applyAlignment() {
      logo.style.translate = '';

      window.requestAnimationFrame(function () {
        var logoBox = logo.getBoundingClientRect();
        var titleBox = title.getBoundingClientRect();

        if (!logoBox.height || !titleBox.height) {
          return;
        }

        logo.style.translate = '0 ' + Math.round(titleBox.top - logoBox.top) + 'px';
        logo.setAttribute('data-slipstream-kiwi-logo-title-top-aligned', '');
      });
    }

    if (logo.complete && logo.naturalWidth) {
      applyAlignment();
    } else {
      logo.addEventListener('load', applyAlignment, { once: true });
    }

    window.setTimeout(applyAlignment, 100);
  }

  function normalisedText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function hideMatchedKiwiImages(chart, match) {
    Array.prototype.forEach.call(match.popup.querySelectorAll('.ks-chart-individual .ks-image'), function (image) {
      image.hidden = true;
      image.setAttribute('data-slipstream-kiwi-native-image-hidden', chart.id);
    });
  }

  function buildPanel(chart, match) {
    var panel = element('section', 'slipstream-kiwi-size-chart-enhancement');
    panel.setAttribute('data-slipstream-kiwi-enhancement', chart.id);

    var navigation = element('nav', 'slipstream-kiwi-size-chart-enhancement__nav');
    navigation.setAttribute('aria-label', 'Size chart units');

    ['imperial', 'metric'].forEach(function (unit) {
      var tab = element('button', 'slipstream-kiwi-size-chart-enhancement__tab');
      tab.type = 'button';
      tab.setAttribute('data-unit-tab', unit);
      tab.textContent = chart.units[unit].label;
      tab.addEventListener('click', function () {
        if (panel.getAttribute('data-active-unit') !== unit) {
          setActiveUnit(chart, panel, match, unit);
        }
      });
      navigation.appendChild(tab);
    });

    var visual = element('div', 'slipstream-kiwi-size-chart-enhancement__visual');
    var image = document.createElement('img');
    image.className = 'slipstream-kiwi-size-chart-enhancement__image';
    image.src = chart.imageSrc;
    image.alt = '';
    visual.appendChild(image);

    ['chest', 'waist', 'hips'].forEach(function (name, index) {
      var measurement = element('p', 'slipstream-kiwi-size-chart-enhancement__measurement slipstream-kiwi-size-chart-enhancement__measurement--' + name);
      measurement.setAttribute('data-measurement', index);
      visual.appendChild(measurement);
    });

    var description = element('p', 'slipstream-kiwi-size-chart-enhancement__description');
    description.setAttribute('data-unit-description', '');

    var fitTable = document.createElement('table');
    fitTable.className = 'slipstream-kiwi-size-chart-enhancement__fit-table';
    fitTable.innerHTML = '<thead><tr>' + chart.fit.map(function (item) {
      return '<th scope="col">' + item[0] + '</th>';
    }).join('') + '</tr></thead><tbody><tr>' + chart.fit.map(function (item) {
      return '<td>' + item[1] + '</td>';
    }).join('') + '</tr></tbody>';

    var heading = element('h2', 'slipstream-kiwi-size-chart-enhancement__heading');
    heading.textContent = 'Size chart';

    panel.appendChild(navigation);
    panel.appendChild(visual);
    panel.appendChild(description);
    panel.appendChild(fitTable);
    panel.appendChild(heading);
    return panel;
  }

  function setActiveUnit(chart, panel, match, unit) {
    panel.setAttribute('data-active-unit', unit);
    match.imperial.block.hidden = unit !== 'imperial';
    match.metric.block.hidden = unit !== 'metric';

    Array.prototype.forEach.call(panel.querySelectorAll('[data-unit-tab]'), function (tab) {
      var active = tab.getAttribute('data-unit-tab') === unit;
      tab.setAttribute('aria-pressed', String(active));
    });

    Array.prototype.forEach.call(panel.querySelectorAll('[data-measurement]'), function (item) {
      var measurement = chart.units[unit].measurements[Number(item.getAttribute('data-measurement'))];
      var parts = measurement.match(/^(.*?:)\s*(.*)$/);

      item.textContent = '';

      if (parts) {
        var label = element('span', 'slipstream-kiwi-size-chart-enhancement__measurement-label');
        var value = element('span', 'slipstream-kiwi-size-chart-enhancement__measurement-value');
        label.textContent = parts[1];
        value.textContent = parts[2];
        item.appendChild(label);
        item.appendChild(document.createTextNode(' '));
        item.appendChild(value);
      } else {
        item.textContent = measurement;
      }
    });
    panel.querySelector('[data-unit-description]').textContent = chart.units[unit].description;
  }

  function element(tagName, className) {
    var node = document.createElement(tagName);
    node.className = className;
    return node;
  }
})(window, document);
